import React from 'react';
import {useTranslation} from 'react-i18next';

import {Modal as BaseModal} from '@pexip/components';
import type {ModalHandle, ModalProps} from '@pexip/components';

export const Modal = React.forwardRef<ModalHandle, ModalProps>((props, ref) => {
    const {t} = useTranslation();

    return (
        <BaseModal
            ref={ref}
            closeButtonAriaLabel={t('common.close', 'Close')}
            scrollbarsAriaLabel={t(
                'common.scrollable-content',
                'Scrollable content',
            )}
            {...props}
        />
    );
});

Modal.displayName = 'Modal';
